import React, { createContext, useState, ReactNode, FC } from 'react';
import PostDetailAchievementAnimation from './PostDetailAchievementAnimation';

const ScheduleActionAnimationContext = createContext<
  ScheduleActionAnimationContextValue | undefined
>(undefined);

export type ScheduleActionAnimationContextValue = {
  displayAnimation: boolean;
  showAnimation: (id: number) => void;
};

export const ScheduleActionAnimationProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [displayAnimation, setDisplayAnimation] = useState(false);

  const contextValue = {
    displayAnimation,
    showAnimation: (id: number) => {
      if (id % 5 === 0 || id === 1) {
        setDisplayAnimation(true);
      }
    },
  };

  return (
    <ScheduleActionAnimationContext.Provider value={contextValue}>
      {displayAnimation && (
        <PostDetailAchievementAnimation
          onAnimationDone={() => setDisplayAnimation(false)}
        />
      )}
      {children}
    </ScheduleActionAnimationContext.Provider>
  );
};

export function useScheduleActionAnimationContext() {
  const context = React.useContext(ScheduleActionAnimationContext);

  if (!context) {
    throw new Error(
      'useScheduleActionAnimationContext must be used within a ScheduleActionAnimationProvider',
    );
  }

  return context;
}
